import { Haptics, ImpactStyle } from '@capacitor/haptics'
import {
    ColoursObj,
    Icon,
    TEventrIcons,
    Typography,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
const opacityFrames = `
    @keyframes highlight {
        0% {
            opacity: 1;
        }

        50%{
            opacity: 0.5;
        }
        
        100% {
            opacity: 1;
        }
    }
`

interface INavBarItemProps {
    id: string
    label: string
    icon: TEventrIcons
    path: string
    active?: boolean
    disabled?: boolean
    pulse?: boolean
    count?: number
    order: number
    onClick?: () => void
}

export const NavBarItem = ({
    id,
    label,
    icon,
    path,
    active,
    disabled,
    pulse,
    count = 0,
    order,
    onClick,
}: INavBarItemProps) => {
    return (
        <Box
            id={id}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            width={'80px'}
            height={'46px'}
            onClick={() => {
                if (disabled) return
                if (path === window.location.pathname) return

                onClick?.()
                Haptics.impact({ style: ImpactStyle.Light })
                window.pushPath(path, { animation: 'none' })
            }}
            sx={{ animation: pulse && 'highlight 2s infinite ease' }}
        >
            {!!count && (
                <Box
                    sx={{
                        position: 'absolute',
                        display: 'grid',
                        backgroundColor: ColoursObj.states.error,
                        borderRadius: '50%',
                        height: '16px',
                        width: '16px',
                        justifyItems: 'center',
                        alignItems: 'center',
                        translate: '16px -22px',
                    }}
                >
                    <Typography
                        color={ColoursObj.shades.shade5}
                        variant="bodySubtext"
                        fontSize={count > 9 ? '8px' : '12px'}
                        lineHeight={count > 9 ? '8px' : '12px'}
                    >
                        {count}
                    </Typography>
                </Box>
            )}
            <Icon
                iconColour={
                    active
                        ? ColoursObj.navbar.highlighted
                        : disabled
                        ? ColoursObj.shades.shade1 + '30'
                        : ColoursObj.navbar.icons
                }
                name={icon}
                width="28px"
                height="28px"
            />
            <Typography
                color={
                    active
                        ? ColoursObj.navbar.highlighted
                        : disabled
                        ? ColoursObj.shades.shade1 + '30'
                        : ColoursObj.navbar.icons
                }
                variant="bodySubtext"
            >
                {label}
            </Typography>
            <style>{opacityFrames}</style>
        </Box>
    )
}
